import {Country} from "@/constants/country";

export interface Address {
    id: number;
    zipCode?: string | undefined;
    houseNumber?: number | undefined;
    houseNumberAddition?: string | undefined;
    country: Country;
    city?: string | undefined;
    street?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export interface Location {
    referencePosition: Position;
    roadAccessPosition?: Position;
    address: Address;
    formattedAddress: string;
}

interface Position {
    latitude: number;
    longitude: number;
}

export interface Suggestion {
    caption: string;
    country: string;
    state: string;
    postalCode: string;
    locality: string;
    street: string;
    houseNumber: string;
}

export const DefaultAddress = () => {
    return {
        id: 0,
        zipCode: undefined,
        houseNumberAddition: undefined,
        houseNumber: undefined,
        country: Country.NL,
        city: undefined,
        street: undefined,
        latitude: 0,
        longitude: 0,
    } as Address
}
